// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".math-content[data-v-4088f5f3]{width:100%;font-size:.32rem}.math-content .question-content[data-v-4088f5f3]{word-wrap:break-word;width:100%}.math-content .question-content[data-v-4088f5f3] input{display:none!important}.math-content .question-content[data-v-4088f5f3] .MathJax_SVG{outline:none}.math-content .question-content[data-v-4088f5f3] img{width:auto!important}.math-content .question-content.opacity-0[data-v-4088f5f3]{opacity:0}", ""]);
// Exports
module.exports = exports;
